export const HOME_URL = '/';
